function PageSupport() {
  return (
    <>
      <div className="min-vh-100"></div>
    </>
  );
}

export default PageSupport;
